import React, {Fragment, ReactElement, useEffect} from 'react';
import {
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
  paymentCheckButton,
} from '../../../redux/globalSlice';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';

import {useState} from 'react';
import {BackButtonAction} from '../../../core/utils/string.util';
import exclamation from '../../../assets/images/exclamation.svg';
import {useHistory, useLocation} from 'react-router-dom';
import home from '../../../assets/images/home.svg';
import {HOME_ROUTE_PATH} from '../../../routes/route-constants';
import {
  getAccessToken,
  getCheckSum,
  getLmrChecked,
  getStoreCode,
  getStoreInformation,
  getUser,
  setTotalCartItems,
} from '../../../core/localstorage-data';
import {
  invoiceGeneratedResponse,
  invoiceGeneratedError,
  resetOrderState,
  setCartItemsCount,
  transactionStatusResponse,
  transactionStatusError,
  transactionStatusResponseLoading,
  invoiceGeneratedLoading,
  orderResponse,
  verifyPaymentStatus,
  paymentStatusError,
  paymentStatusLoading,
  paymentStatus,
  generateInvoice,
  resetInvoiceResponse,
  resetTransactionResponse,
  checkTransactionStatus,
  resetPaymentStatus,
} from '../../../redux/orderSlice';
import {
  errorInVerifypayment,
  paymentVerifyResponse,
  verifyPaymentLoading,
} from '../../../redux/paymentVerificationSlice';
import cogoToast from 'cogo-toast';
import ErrorToast from '../../../components/notifications/ErrorToast';
let invoiceStatus = true;
const PaymentError = (): ReactElement => {
  const navigate = useHistory();
  const verifyPaymentResp = useAppSelector(paymentStatus);
  const checksum = getCheckSum();
  const lmrChecked = getLmrChecked();
  const errorInPaymentStatus = useAppSelector(paymentStatusError);
  const paymentStatusLoaded = useAppSelector(paymentStatusLoading);

  const dispatch = useAppDispatch();
  const paymentStatuss = useAppSelector(paymentCheckButton);
  const storeCode = `0${getStoreInformation().store_code}`;
  const accessToken = getAccessToken();
  const card_number = getUser().cardNumber;
  const {state}: any = useLocation();
  const paymentVerifyResp = useAppSelector(paymentVerifyResponse);
  const verifyPaymentError = useAppSelector(errorInVerifypayment);
  const verifyPaymentHasLoaded = useAppSelector(verifyPaymentLoading);
  const invoiceResponse = useAppSelector(invoiceGeneratedResponse);
  const [verifyStatus, setVerifyPaymentStatus] = useState(false);
  const transactionStatusResp = useAppSelector(transactionStatusResponse);
  const orderResp = useAppSelector(orderResponse);
  const transactionStatusRespError = useAppSelector(transactionStatusError);
  const invoiGenerationError = useAppSelector(invoiceGeneratedError);
  const transactionStatusLoading = useAppSelector(
    transactionStatusResponseLoading,
  );
  const invoiceLoading = useAppSelector(invoiceGeneratedLoading);
  console.log('Order Response', orderResp?.orderId);
  const [errorMessage, setErrorMessage] = useState(
    'We have not received your payment. If money has been deducted from your account it will be refunded within 7 working days.',
  );
  const storeId = getStoreCode();
  useEffect(() => {
    dispatch(setAppBarTitle('Payment Error'));
    dispatch(setBackNavEnabled(true));

    dispatch(resetPaymentStatus());
    //add it to missing size
    dispatch(setBackNavAction(BackButtonAction.TO_HOME));

    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      dispatch(setBackNavAction(undefined));
      localStorage.removeItem('lmrchecked');

      console.log('ssssssssssssssssssssssssssssssssssssssss', invoiceStatus);

      if (invoiceStatus == true) {
        console.log('ttttttttttttttttttttttttttttttttt', invoiceStatus);
        //dispatch(resetOrderState());
        dispatch(resetOrderState());
      }
      dispatch(setCartItemsCount(0));

      setTotalCartItems(0);
    };
  }, []);

  useEffect(() => {
    if (!invoiceResponse) {
      if (invoiceResponse != null) {
        console.log('invoice response');
        setErrorMessage(invoiceResponse.message);
      }
    }
    if (invoiGenerationError != null) {
      console.log('invoice error');
      setErrorMessage(
        'Lmr points can not be redeem at this moment. Please try after some time',
      );
    }
  }, []);
  useEffect(() => {
    if (transactionStatusResp) {
      if (transactionStatusResp.statusCode === '200') {
        //redirect to confirm page
        invoiceStatus = false;
        navigate.push('/checkout/confirm');
      } else {
        invoiceStatus = false;
        navigate.push('/checkout/confirm');
      }
    }
    if (
      transactionStatusLoading === false &&
      transactionStatusRespError != ''
    ) {
      invoiceStatus = false;
      navigate.push('/checkout/confirm');
    }
  }, [
    transactionStatusResp,
    transactionStatusLoading,
    transactionStatusRespError,
  ]);

  useEffect(() => {
    if (invoiceResponse !== null) {
      if (invoiceResponse.txnStatus === 'completed') {
        invoiceStatus = false;
        navigate.push('/checkout/confirm');
      } else {
        if (invoiceResponse.statusCode === '1053') {
          invoiceStatus = false;
          navigate.push('/checkout/confirm');
        }

        if (
          invoiceResponse.statusCode === '1054' ||
          invoiceResponse.statusCode === '1055' ||
          invoiceResponse.statusCode === '1056' ||
          invoiceResponse.statusCode === '1057'
        ) {
          //navigate.push('/checkout/payment_error');
          cogoToast.error(
            <ErrorToast title="Error" description="Payment Not processed" />,
            {
              hideAfter: 2,
              renderIcon: () => {
                return null;
              },
            },
          );
        } else {
          const orderId = orderResp?.orderId;
          if (orderId != undefined) {
            const parameters = {
              accessToken,
              payload: {
                storeCode: storeCode,
                orderId: orderId,
              },
            };
            dispatch(checkTransactionStatus(parameters));
          }
        }
      }
    }
    if (invoiGenerationError !== null) {
      if (invoiGenerationError.message != '' && invoiceLoading === false) {
        if (invoiGenerationError.error === 'lmrPointsRedumption') {
          cogoToast.error(
            <ErrorToast title="Error" description="Payment Not processed" />,
            {
              hideAfter: 2,
              renderIcon: () => {
                return null;
              },
            },
          );
        } else {
          invoiceStatus = false;
          navigate.push('/checkout/confirm');
        }
      }
    }
  }, [invoiceResponse, invoiGenerationError, invoiceLoading]);
  useEffect(() => {
    const orderId = orderResp?.orderId;
    if (verifyPaymentResp !== null && paymentStatusLoaded === false) {
      if (
        verifyPaymentResp !== null &&
        verifyPaymentResp.resultStatus === 'TXN_SUCCESS'
      ) {
        if (orderId != undefined) {
          const parameters = {
            accessToken,
            payload: {
              storeCode,
              orderId: orderId,
              redeemLMR: lmrChecked === null ? false : lmrChecked,
            },
          };
          dispatch(generateInvoice(parameters));
        }
      } else if (
        verifyPaymentResp !== null &&
        verifyPaymentResp.resultStatus === 'TXN_FAILURE' &&
        verifyStatus === true
      ) {
        dispatch(resetInvoiceResponse());
        dispatch(resetTransactionResponse());
        // navigate.push('/checkout/payment_error');
        cogoToast.error(
          <ErrorToast title="Error" description="Payment Not processed" />,
          {
            hideAfter: 2,
            renderIcon: () => {
              return null;
            },
          },
        );
      } else if (
        verifyPaymentResp !== null &&
        verifyPaymentResp.resultStatus != 'TXN_FAILURE' &&
        verifyPaymentResp.resultStatus != 'TXN_SUCCESS'
      ) {
        dispatch(resetInvoiceResponse());
        dispatch(resetTransactionResponse());
        // navigate.push('/checkout/payment_error');
        cogoToast.error(
          <ErrorToast title="Error" description="Payment Not processed" />,
          {
            hideAfter: 2,
            renderIcon: () => {
              return null;
            },
          },
        );
      }
    }
    if (
      errorInPaymentStatus != '' &&
      verifyStatus === true &&
      paymentStatusLoaded === false
    ) {
      cogoToast.error(
        <ErrorToast title="Error" description="Payment Not processed" />,
        {
          hideAfter: 2,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [verifyPaymentResp, errorInPaymentStatus, paymentStatusLoaded]);

  const StatusHandler = () => {
    setVerifyPaymentStatus(true);
    console.log('Order Response', orderResp?.orderId);
    const orderId = orderResp?.orderId;
    //  const checksum = 'sagar garg';
    if (accessToken != null && orderId != undefined) {
      const parameters = {
        accessToken,
        payload: {
          checksum,
          storeCode,
          orderId,
          verifyPaymentRetryCount: -1,
        },
        // access_token: 'test',
      };
      dispatch(verifyPaymentStatus(parameters));
      //
    }
  };

  const buttonHandler = () => {
    navigate.push(HOME_ROUTE_PATH);
  };

  return (
    <Fragment>
      <div className="container mx-auto z-10 p-4 bg-color">
        <div className="w-auto ">
          <div className=" grid place-items-center">
            <img src={exclamation} />
          </div>
          <div className="flex justify-center items-center">
            <div className="text-big font-roboto font-light">
              Purchase Error
            </div>
          </div>
          <div className="flex justify-center items-center mb-2">
            <div className="mt-2 grid text-center text-black text-opacity-50">
              {errorMessage}
            </div>
          </div>
          <div>
            {paymentStatuss ? (
              <button
                className="cursor-none-allowed text-white  rounded-radius10  grid place-items-center focus:outline-none mx-auto p-3 text-center primary normal mb-2"
                onClick={StatusHandler}
                disabled={verifyStatus}>
                Payment Status
              </button>
            ) : (
              ''
            )}
          </div>
          {state ? (
            ''
          ) : (
            <div className="text-left">
              <div className="font-roboto shadow-max p-4">
                <div className="font-medium text-small mb-4">
                  Instructions to proceed
                </div>
                <div className="text-small mb-1">1. Go to Homepage</div>
                <div className="text-small mb-1">
                  2. Click menu, go to All orders.
                </div>
                <div className="text-small mb-1">
                  3. Check pending Orders tab.
                </div>
              </div>
            </div>
          )}
          <div className="mt-6">
            <div className="flex justify-between">
              <button
                className={`text-white h-12 px-3 w-full rounded-radius10 border-solid border border-gray-400 grid place-items-center focus:outline-none text-center font-medium                secondary normal`}
                onClick={buttonHandler}>
                <div className="flex">
                  <div>
                    <img src={home} />
                  </div>

                  <div className="ml-2">
                    {' '}
                    <span className="text-roboto text-black">Home</span>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default PaymentError;
